import React from "react";
import MessageBubble from "./MessageBubble";

export default function MessageList({
  messages,
  userData,
  accountIndex,
  elementRef,
  onAssetOpen,
  onFileDownload,
}) {
  const reversedMessages = messages?.messages?.slice()?.reverse();

  return (
    <div
      ref={elementRef}
      style={{ backgroundImage: "url(/assets/images/chat-bg.svg)" }}
      className={`messaging__chat-content ${
        !userData?.id ? "messaging__chat-content_hide" : ""
      } ${
        userData?.id && userData?.status === "completed"
          ? "messaging__chat-content_bottom"
          : ""
      }`}
    >
      {userData?.id &&
        reversedMessages?.map((item, index) => (
          <MessageBubble
            key={item?.id || `${item?.updated_at}-${index}`}
            item={item}
            accountIndex={accountIndex}
            userData={userData}
            onAssetOpen={onAssetOpen}
            onFileDownload={onFileDownload}
          />
        ))}
    </div>
  );
}
